export { default } from './SelectedOption';
